import clsx from 'clsx'

interface Props {
  heading?: string
}

export function Seperator({ heading }: Props) {
  return (
    <div className={clsx('flex flex-row items-center w-full gap-4 my-4')}>
      <div className="flex-1 h-[2px] rounded bg-text-light" />
      {heading && (
        <>
          <span className="text-heading3 text-text">{heading}</span>
          <div className="flex-1 h-[2px] rounded bg-text-light" />
        </>
      )}
    </div>
  )
}
